function removeSession () {
  sessionStorage.removeItem('flujo')
}

export default removeSession
